const ImagePreview = ({canvasRef, canvasCursor, onMouseDown = () => {}, onMouseMove = () => {}, onMouseUp = () => {}}) => {
    return <canvas ref={canvasRef} style={{ cursor: canvasCursor }}
    width={304} height={304}
    onMouseDown={onMouseDown}
    onMouseMove={onMouseMove}
    onMouseUp={onMouseUp}
    onMouseLeave={onMouseUp} />
}

export default ImagePreview;